<template>
  <page title="Read Pages">
    <div class="box">
      <div class="mb-4" v-if="readPages.response.data">
        <b-tag v-if="readPages.response.data.magazine" closable @close="removeQuery('magazine_id')">{{
        readPages.response.data.magazine.name }}</b-tag>
      </div>

      <b-table :data="readPages.data" :loading="readPages.loading" paginated backend-pagination
        pagination-position="bottom" :current-page="readPages.current_page" :per-page="readPages.per_page"
        :total="readPages.total" @page-change="page => readPages.changePage(page)" backend-sorting
        @sort="(field, direction) => readPages.sort(field, direction)" :default-sort="['id', 'desc']" class="is-middle">
        <template slot-scope="props">
          <b-table-column label="User" style="width: 15%;">
            <div class="truncate" style="max-width: 100%;">
              <router-link v-if="props.row.user" :to="'/users/' + props.row.user.id" target="_blank">{{
              props.row.user.name }}</router-link>
            </div>
          </b-table-column>

          <b-table-column field="issue_id" label="Issue" style="width: 15%;">
            <div class="truncate" style="max-width: 100%;">
              <span class="has-text-grey">{{ props.row.issue.magazine.name }}</span>
              <span class="ml-2 mr-2">/</span>
              <span>{{ props.row.issue.title }}</span>
            </div>
          </b-table-column>

          <b-table-column field="page" label="Page" style="width: 5%;" centered>
            <span>{{ props.row.page }}</span>
          </b-table-column>

          <b-table-column field="read_seconds" label="Read Seconds" centered>{{ props.row.read_seconds }}
          </b-table-column>

          <b-table-column field="read_at" label="Read At" sortable>
            <b-tooltip :label="props.row.read_at">{{ props.row.read_at | date }}</b-tooltip>
          </b-table-column>
        </template>

        <template slot="empty">
          <empty-message></empty-message>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
export default {
  data() {
    return {
      readPages: new window.PaginatedRemoteCollection(
        "/admin/api/magazine/stats/read-pages"
      )
    };
  },

  created() {
    this.load();
  },

  watch: {
    "$route.query"() {
      this.load();
    }
  },

  methods: {
    load() {
      this.readPages.filter(this.$route.query, true).load();
    },

    removeQuery(field) {
      let query = Object.assign({}, this.$route.query);

      delete query[field];

      this.$router.replace({
        path: this.$route.path,
        query
      });
    }
  }
};
</script>
